import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PopularProperties() {
  const { t } = useTranslation();
  return (
    <div className="popular-property-wrapper">
      <div className="label">{t('cms.dashboard.strategy.module_setting.popularProperties')}</div>
      <div className="right-wrapper">{t('cms.dashboard.strategy.homepage_setting.tips')}</div>
    </div>
  );
}
